var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdultsOnlyStandingPosition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.74 18.1199C41.4131 18.1199 43.58 15.953 43.58 13.2799C43.58 10.6069 41.4131 8.43994 38.74 8.43994C36.067 8.43994 33.9 10.6069 33.9 13.2799C33.9 15.953 36.067 18.1199 38.74 18.1199Z",
    fill: "#FF6AA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.08 41.2399C33.18 47.8799 29.96 54.2799 25.36 59.0799C25.1 59.3599 24.6 59.1399 24.64 58.7599C24.66 52.1799 26.24 45.3799 26.44 39.2199C26.44 38.1799 26.38 37.1399 26.34 36.0799C26.54 35.9399 26.72 35.7999 26.92 35.6599C27.12 36.1399 27.36 36.6399 27.72 37.1799C28.88 39.3399 31.46 40.8999 34.08 41.2399Z",
    fill: "#00A6ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.38 26.1199C26.2 26.1999 26.04 26.2799 25.88 26.3599C25.84 24.1199 25.9 21.8399 26.18 19.5799C27.36 16.5999 30.76 23.4199 32.18 26.8599C30.52 25.7799 28.52 25.3399 26.38 26.1199Z",
    fill: "#00A6ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.72 16.5999C30.3931 16.5999 32.56 14.433 32.56 11.7599C32.56 9.08686 30.3931 6.91992 27.72 6.91992C25.0469 6.91992 22.88 9.08686 22.88 11.7599C22.88 14.433 25.0469 16.5999 27.72 16.5999Z",
    fill: "#00A6ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.54 20.18C41.04 19.6 40 20.02 40.08 20.8C40.28 25.46 39.1 29.48 35.92 32.06C35.7 32.22 35.5 32.32 35.34 32.38C35.34 32.36 35.3 32.34 35.28 32.3C34.12 30.04 32.92 27.78 30.1 26.9C23.08 25.36 20.4 34.08 20.48 39.3C20.48 39.66 20.92 39.88 21.2 39.66C23.28 38.24 25.44 35.8 27.46 34.44C28.88 38.48 33.22 41.62 37.6 39.8C45.16 36.7 46.66 25.58 41.54 20.16V20.18Z",
    fill: "#FF6AA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdultsOnlyStandingPosition);
export default __webpack_public_path__ + "static/media/adults_only_standing_position.2d4faf82e16f8eae937430778a4f0d21.svg";
export { ForwardRef as ReactComponent };